import { Box, TextField, InputAdornment, TableContainer, Table, TableBody, TableRow, TableCell, Checkbox, IconButton, Popover, MenuItem, Typography, Avatar, FormControl, InputLabel, Select, Grid, TableHead, Divider, LinearProgress } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { useTranslation } from "react-i18next";
import { numberFormat } from "../../utils/nunberFormat";
import { DEFAULT_ROWS_PER_PAGE } from "../../config-global";
import Pagination from '@mui/material/Pagination';
import { SELECT_BACKGROUND_COLOR, TEXT_TITLE_COLOR } from "../../constants/colors";
import ProductTabPanel from "./components/tabPanel";
import ACTIVE_PRODUCT_STATISTIC from '../../assets/images/active_product_static.svg';
import InfoIcon from '@mui/icons-material/Info';
import useOrderController from "./controller/orderController";
import { IMAGE_CUSTOMER } from "../../lib/endpoints/customer";
import { OrderModel } from "../../models/order";
import OrderDetail from "./Detail";
import { OrderStatusEnum } from "../../enums/orderStatus";
import { EN_ACCEPT_LANGUAGE } from "../../constants/acceptLanguageApi";
import { RootState } from "../../store";
import { useSelector } from "react-redux";
import LoadingAnimatedIcon from "../../components/loading/loadingAnimated";
import { ShipmentMethodEnum } from "../../enums/shipmentMethod";
import ShipmentMethodChip from "../../components/ShipmentMethodChip";
import SelectedBranchComponentVoid from "../../components/SelectedBranchVoid";

const OrderView = () => {
    const { t, i18n } = useTranslation("global");

    const controller = useOrderController();
    const newOrderId: string[] = useSelector((state: RootState) => state?.notificationSlice?.newOrderId);
    const tableHeaders: string[] = [t("order_page.No"), t("order_page.Customer name"), t("order_page.Order ID"), t("order_page.Order number"), t("order_page.Shipment method"), controller.currentOrderStatus === OrderStatusEnum.Rider_Getting_Order ? t("order_page.Driver Name") : t("order_page.Phone"), t("order_page.Price"), t("order_page.Branch"), "", ""];
    return <Box>
        {
            !controller.loading
                ?
                !controller.selectedData
                    ?
                    <Box>
                        <Box mb={3} >
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2, width: '100%' }}>
                                <Typography variant="h4" fontWeight="bold" color={TEXT_TITLE_COLOR}>{t('order_page.Order management')}</Typography>
                                <TextField onKeyDown={(e: any) => {
                                    if (e.key === "Enter") {
                                        controller.handleGetDataByOrderId();
                                    }
                                }} inputRef={controller.searchRef} fullWidth sx={{ maxWidth: 250 }} placeholder={t('order_page.Search by Order ID') || ''} InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start" onClick={controller.handleGetDataByOrderId}>
                                            <SearchIcon />
                                        </InputAdornment>
                                    )
                                }} size="small" />
                                {/* <TextField type="date" fullWidth sx={{
                                    maxWidth: 150, "& .MuiOutlinedInput-root": {
                                        "& > fieldset": {
                                            border: "none"
                                        }
                                    }
                                }} size="small" label="Select start date" InputProps={{
                                    disableUnderline: true,
                                    style: {
                                        backgroundColor: SELECT_BACKGROUND_COLOR,
                                        borderRadius: '8px'
                                    }
                                }} InputLabelProps={{ shrink: true }} /> */}
                                {/* <TextField type="date" fullWidth sx={{
                                    maxWidth: 150, "& .MuiOutlinedInput-root": {
                                        "& > fieldset": {
                                            border: "none"
                                        }
                                    }
                                }} size="small" label="Select end date" InputProps={{
                                    disableUnderline: true,
                                    style: {
                                        backgroundColor: SELECT_BACKGROUND_COLOR,
                                        borderRadius: '8px'
                                    }
                                }} InputLabelProps={{ shrink: true }} /> */}
                                {/* <FormControl fullWidth sx={{ maxWidth: 148 }}>
                                    <InputLabel id="shipment-method-label-id">Select shipment method</InputLabel>
                                    <Select
                                        labelId="shipment-method-label-id"
                                        id="shipment-method-id"
                                        value="COD"
                                        label="Shipment method"
                                        size="small"
                                        sx={{ bgcolor: SELECT_BACKGROUND_COLOR, '.MuiOutlinedInput-notchedOutline': { border: 0 }, borderRadius: '8px' }}
                                    // onChange={handleChange}
                                    >
                                        <MenuItem value="COD">Cod</MenuItem>
                                    </Select>
                                </FormControl> */}
                                {/* <FormControl fullWidth sx={{ maxWidth: 160 }}>
                                    <InputLabel id="merchant-label">{t("order_page.Branch")}</InputLabel>
                                    <Select
                                        labelId="merchant-label"
                                        id="merchant-id"
                                        label="Branch"
                                        value={controller.merchantValue || "All"}
                                        size="small"
                                        sx={{ bgcolor: SELECT_BACKGROUND_COLOR, '.MuiOutlinedInput-notchedOutline': { border: 0 }, borderRadius: '8px' }}
                                        onChange={(e) => controller.handleSelectedMerchant(e.target.value)}
                                    >
                                        <MenuItem sx={{ display: controller.roleAdmin === 'SUPER_ADMIN' ? 'block' : 'none' }} value="All">{t("order_page.All")}</MenuItem>
                                        {
                                            controller.merchantData?.map((branch) => (
                                                <MenuItem key={branch.id} value={branch.id}>
                                                    {i18n.language === EN_ACCEPT_LANGUAGE ? branch?.nameEn : branch?.nameLa}
                                                </MenuItem>
                                            ))
                                        }
                                    </Select>
                                </FormControl> */}
                                <SelectedBranchComponentVoid value={controller.merchantValue || "All"} onSelectMerchant={controller.handleSelectedMerchant} merchantData={controller.merchantData} role={controller.roleAdmin} />
                            </Box>

                        </Box>

                        <Box mb={2}>
                            <ProductTabPanel value={controller.currentOrderStatus} onChange={controller.handleCurrentOrderStatusChange} />
                        </Box>

                        <Box mb={2}>
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6} md={4}>
                                    <Box sx={{ backgroundColor: '#C4EAFF', borderRadius: '16px', p: 4, display: 'flex', justifyContent: 'space-between' }}>
                                        <Box>
                                            <Typography color="#005249" sx={{ mb: 1 }}>{t('order_page.Amount')}</Typography>
                                            <Typography color="#005249" fontWeight="bold" fontSize={32}>{numberFormat(controller.sourceData?.length)} {t('order_page.Orders')}</Typography>
                                        </Box>
                                        <Box>
                                            <img src={ACTIVE_PRODUCT_STATISTIC} alt="" style={{ width: 100, height: 100 }} />
                                        </Box>
                                    </Box>
                                </Grid>

                            </Grid>
                        </Box>


                        {
                            !controller.loadingGetData
                                ?
                                <Box sx={{ mt: 2 }}>
                                    <TableContainer>
                                        <Table>
                                            <TableHead sx={{ background: '#F4F6F8' }}>
                                                <TableRow>
                                                    {
                                                        tableHeaders?.map((item, index) => <TableCell key={index} sx={{ borderBottom: 'none' }}>{item}</TableCell>)
                                                    }

                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {
                                                    controller.rows?.map((row: OrderModel, index: number) => {
                                                        const customerImage: string = IMAGE_CUSTOMER + row?.customer?.profile?.image?.url;
                                                        return (
                                                            <TableRow hover key={row?.id} tabIndex={-1}>
                                                                <TableCell align="left" sx={{ borderBottom: 'none' }}>{numberFormat((index + 1) + (DEFAULT_ROWS_PER_PAGE * (controller.currentPage - 1)))}</TableCell>
                                                                <TableCell align="left" sx={{ borderBottom: 'none' }}>
                                                                    <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                                                                        <Avatar
                                                                            src={customerImage}
                                                                            alt='Customer'
                                                                            sx={{ cursor: 'pointer', objectFit: 'contain', borderRadius: 12, width: 50, height: 50 }}
                                                                            onClick={() => window.open(customerImage)}
                                                                        />
                                                                        <Typography>{row?.customer?.profile?.fullName}</Typography>
                                                                    </Box>

                                                                </TableCell>
                                                                <TableCell align="left" sx={{ borderBottom: 'none' }}>{row?.orderNo}</TableCell>
                                                                <TableCell align="left" sx={{ borderBottom: 'none' }}>{row?.orderNumber}</TableCell>
                                                                <TableCell align="left" sx={{ borderBottom: 'none' }}><ShipmentMethodChip value={row?.orderMethod as ShipmentMethodEnum} /></TableCell>
                                                                {/* <TableCell align="left" sx={{ borderBottom: 'none' }}>{row?.orderMethod}</TableCell>
                                                                <TableCell align="left" sx={{ borderBottom: 'none' }}>{row?.paymentMethod}</TableCell> */}
                                                                <TableCell align="left" sx={{ borderBottom: 'none' }}>{controller.currentOrderStatus === OrderStatusEnum.Rider_Getting_Order ? row?.rider?.profile?.fullName : row?.orderMethod === ShipmentMethodEnum.PICK_UP ? row?.customer?.phone : row?.customer?.phone}</TableCell>
                                                                <TableCell align="left" sx={{ borderBottom: 'none' }}>{numberFormat(row?.totoalWithDeliveryFee)} kip</TableCell>
                                                                <TableCell align="left" sx={{ borderBottom: 'none' }}>{i18n.language === EN_ACCEPT_LANGUAGE ? row?.merchant?.nameEn : row?.merchant?.nameLa}</TableCell>
                                                                <TableCell align="left" sx={{ borderBottom: 'none' }}><span style={{ width: 70, background: "#DB1F35", borderRadius: '6px', padding: "5px 10px", color: 'white', display: newOrderId.includes(row?.id) ? "block" : "none" }}>{t("order_page.New order")}</span></TableCell>
                                                                <TableCell align="right" sx={{ borderBottom: 'none' }}>
                                                                    <IconButton size="large" color="inherit" onClick={(e: any) => controller.handleOpenMenu(e, row?.id)}>
                                                                        <MoreHorizIcon />
                                                                    </IconButton>
                                                                </TableCell>
                                                            </TableRow>
                                                        )
                                                    })
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <Divider sx={{ mt: 1, mb: 1 }} />
                                    {
                                        controller.loadingFetchDataMore
                                        &&
                                        <Box mb={2} mt={2}>
                                            <LinearProgress />
                                        </Box>
                                    }
                                    <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                                        <Pagination color="primary" onChange={controller.handlePageChange} page={controller.currentPage} count={controller.countPagination} />
                                    </Box>
                                </Box>
                                :
                                <LinearProgress sx={{ mt: 2 }} />
                        }
                        <Popover
                            open={Boolean(controller.openMenu)}
                            anchorEl={controller.openMenu}
                            onClose={controller.handleCloseMenu}
                            anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                            PaperProps={{
                                sx: {
                                    p: 1,
                                    width: 140,
                                    '& .MuiMenuItem-root': {
                                        px: 1,
                                        typography: 'body2',
                                        borderRadius: 0.75,
                                    },
                                },
                            }}
                        >
                            <MenuItem onClick={controller.handleClickViewData}>
                                <InfoIcon />
                                &nbsp;&nbsp;
                                {t("order_page.See Detail")}
                            </MenuItem>
                        </Popover>

                    </Box>
                    :

                    <OrderDetail onRefetchData={controller.handleRefetchData} selectedData={controller.selectedData} onClose={controller.handleCloseForm} orderStatus={controller.currentOrderStatus} />


                :
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <LoadingAnimatedIcon />
                </Box>
        }
    </Box>
}
export default OrderView;